import { render, staticRenderFns } from "./ProofComment.vue?vue&type=template&id=010200b6"
import script from "./ProofComment.vue?vue&type=script&lang=js"
export * from "./ProofComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports